import {
  changeBusinessUser,
  getMyUserGroupPage,
  getMyUserGroupAll,
  modifyObj,
  addObj,
  getPage,
  getAll,
  deleteObj,
  getDetail,
  uploadMaintainPicture,
  removeMaintainPicture,
  getMyBusinessPage,
  getMyGroupNotMaintainNum,
  getMyMaintainGroupPage,
  getMaintainGroupTeamReport,
  getMyNotMaintainNum,
  confirmMaintained,
  addMaintainDeviceRecord,
  changeMaintainer,
  getMyMaintainPage,
  forceConfirmMaintained,
  modifyMaintainDeviceRecord,
  getCanMakeRecordDevices,
  removeMaintainDeviceRecord,
  addToRemark,
  callBack,
  getTeamReport,
  distribution,
  cancel,
  reschedule,
} from '@/api/maintainorderserv'

export default {
  state: {
    state_MaintainOrder_ChangeBusinessUserResult: null,
    state_MaintainOrder_GetMyUserGroupPageResult: null,
    state_MaintainOrder_GetMyUserGroupAllResult: null,
    state_MaintainOrder_ModifyObjResult: null,
    state_MaintainOrder_AddObjResult: null,
    state_MaintainOrder_GetPageResult: null,
    state_MaintainOrder_GetAllResult: null,
    state_MaintainOrder_DeleteObjResult: null,
    state_MaintainOrder_GetDetailResult: null,
    state_MaintainOrder_UploadMaintainPictureResult: null,
    state_MaintainOrder_RemoveMaintainPictureResult: null,
    state_MaintainOrder_GetMyBusinessPageResult: null,
    state_MaintainOrder_GetMyGroupNotMaintainNumResult: null,
    state_MaintainOrder_GetMyMaintainGroupPageResult: null,
    state_MaintainOrder_GetMaintainGroupTeamReportResult: null,
    state_MaintainOrder_GetMyNotMaintainNumResult: null,
    state_MaintainOrder_ConfirmMaintainedResult: null,
    state_MaintainOrder_AddMaintainDeviceRecordResult: null,
    state_MaintainOrder_ChangeMaintainerResult: null,
    state_MaintainOrder_GetMyMaintainPageResult: null,
    state_MaintainOrder_ForceConfirmMaintainedResult: null,
    state_MaintainOrder_ModifyMaintainDeviceRecordResult: null,
    state_MaintainOrder_GetCanMakeRecordDevicesResult: null,
    state_MaintainOrder_RemoveMaintainDeviceRecordResult: null,
    state_MaintainOrder_AddToRemarkResult: null,
    state_MaintainOrder_CallBackResult: null,
    state_MaintainOrder_GetTeamReportResult: null,
    state_MaintainOrder_DistributionResult: null,
    state_MaintainOrder_CancelResult: null,
    state_MaintainOrder_RescheduleResult: null,
  },
  mutations: {
    SET_MAINTAINORDER_CHANGEBUSINESSUSER_RESULT: (state, rst) => {
      state.state_MaintainOrder_ChangeBusinessUserResult = rst;
    },
    SET_MAINTAINORDER_GETMYUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_MaintainOrder_GetMyUserGroupPageResult = rst;
    },
    SET_MAINTAINORDER_GETMYUSERGROUPALL_RESULT: (state, rst) => {
      state.state_MaintainOrder_GetMyUserGroupAllResult = rst;
    },
    SET_MAINTAINORDER_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_MaintainOrder_ModifyObjResult = rst;
    },
    SET_MAINTAINORDER_ADDOBJ_RESULT: (state, rst) => {
      state.state_MaintainOrder_AddObjResult = rst;
    },
    SET_MAINTAINORDER_GETPAGE_RESULT: (state, rst) => {
      state.state_MaintainOrder_GetPageResult = rst;
    },
    SET_MAINTAINORDER_GETALL_RESULT: (state, rst) => {
      state.state_MaintainOrder_GetAllResult = rst;
    },
    SET_MAINTAINORDER_DELETEOBJ_RESULT: (state, rst) => {
      state.state_MaintainOrder_DeleteObjResult = rst;
    },
    SET_MAINTAINORDER_GETDETAIL_RESULT: (state, rst) => {
      state.state_MaintainOrder_GetDetailResult = rst;
    },
    SET_MAINTAINORDER_UPLOADMAINTAINPICTURE_RESULT: (state, rst) => {
      state.state_MaintainOrder_UploadMaintainPictureResult = rst;
    },
    SET_MAINTAINORDER_REMOVEMAINTAINPICTURE_RESULT: (state, rst) => {
      state.state_MaintainOrder_RemoveMaintainPictureResult = rst;
    },
    SET_MAINTAINORDER_GETMYBUSINESSPAGE_RESULT: (state, rst) => {
      state.state_MaintainOrder_GetMyBusinessPageResult = rst;
    },
    SET_MAINTAINORDER_GETMYGROUPNOTMAINTAINNUM_RESULT: (state, rst) => {
      state.state_MaintainOrder_GetMyGroupNotMaintainNumResult = rst;
    },
    SET_MAINTAINORDER_GETMYMAINTAINGROUPPAGE_RESULT: (state, rst) => {
      state.state_MaintainOrder_GetMyMaintainGroupPageResult = rst;
    },
    SET_MAINTAINORDER_GETMAINTAINGROUPTEAMREPORT_RESULT: (state, rst) => {
      state.state_MaintainOrder_GetMaintainGroupTeamReportResult = rst;
    },
    SET_MAINTAINORDER_GETMYNOTMAINTAINNUM_RESULT: (state, rst) => {
      state.state_MaintainOrder_GetMyNotMaintainNumResult = rst;
    },
    SET_MAINTAINORDER_CONFIRMMAINTAINED_RESULT: (state, rst) => {
      state.state_MaintainOrder_ConfirmMaintainedResult = rst;
    },
    SET_MAINTAINORDER_ADDMAINTAINDEVICERECORD_RESULT: (state, rst) => {
      state.state_MaintainOrder_AddMaintainDeviceRecordResult = rst;
    },
    SET_MAINTAINORDER_CHANGEMAINTAINER_RESULT: (state, rst) => {
      state.state_MaintainOrder_ChangeMaintainerResult = rst;
    },
    SET_MAINTAINORDER_GETMYMAINTAINPAGE_RESULT: (state, rst) => {
      state.state_MaintainOrder_GetMyMaintainPageResult = rst;
    },
    SET_MAINTAINORDER_FORCECONFIRMMAINTAINED_RESULT: (state, rst) => {
      state.state_MaintainOrder_ForceConfirmMaintainedResult = rst;
    },
    SET_MAINTAINORDER_MODIFYMAINTAINDEVICERECORD_RESULT: (state, rst) => {
      state.state_MaintainOrder_ModifyMaintainDeviceRecordResult = rst;
    },
    SET_MAINTAINORDER_GETCANMAKERECORDDEVICES_RESULT: (state, rst) => {
      state.state_MaintainOrder_GetCanMakeRecordDevicesResult = rst;
    },
    SET_MAINTAINORDER_REMOVEMAINTAINDEVICERECORD_RESULT: (state, rst) => {
      state.state_MaintainOrder_RemoveMaintainDeviceRecordResult = rst;
    },
    SET_MAINTAINORDER_ADDTOREMARK_RESULT: (state, rst) => {
      state.state_MaintainOrder_AddToRemarkResult = rst;
    },
    SET_MAINTAINORDER_CALLBACK_RESULT: (state, rst) => {
      state.state_MaintainOrder_CallBackResult = rst;
    },
    SET_MAINTAINORDER_GETTEAMREPORT_RESULT: (state, rst) => {
      state.state_MaintainOrder_GetTeamReportResult = rst;
    },
    SET_MAINTAINORDER_DISTRIBUTION_RESULT: (state, rst) => {
      state.state_MaintainOrder_DistributionResult = rst;
    },
    SET_MAINTAINORDER_CANCEL_RESULT: (state, rst) => {
      state.state_MaintainOrder_CancelResult = rst;
    },
    SET_MAINTAINORDER_RESCHEDULE_RESULT: (state, rst) => {
      state.state_MaintainOrder_RescheduleResult = rst;
    },
  },
  actions: {
    MaintainOrderServ_ChangeBusinessUser({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        changeBusinessUser(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_CHANGEBUSINESSUSER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_CHANGEBUSINESSUSER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_GetMyUserGroupPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_GETMYUSERGROUPPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_GETMYUSERGROUPPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_GetMyUserGroupAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyUserGroupAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_GETMYUSERGROUPALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_GETMYUSERGROUPALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_UploadMaintainPicture({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        uploadMaintainPicture(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_UPLOADMAINTAINPICTURE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_UPLOADMAINTAINPICTURE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_RemoveMaintainPicture({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        removeMaintainPicture(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_REMOVEMAINTAINPICTURE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_REMOVEMAINTAINPICTURE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_GetMyBusinessPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyBusinessPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_GETMYBUSINESSPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_GETMYBUSINESSPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_GetMyGroupNotMaintainNum({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyGroupNotMaintainNum(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_GETMYGROUPNOTMAINTAINNUM_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_GETMYGROUPNOTMAINTAINNUM_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_GetMyMaintainGroupPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyMaintainGroupPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_GETMYMAINTAINGROUPPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_GETMYMAINTAINGROUPPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_GetMaintainGroupTeamReport({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMaintainGroupTeamReport(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_GETMAINTAINGROUPTEAMREPORT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_GETMAINTAINGROUPTEAMREPORT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_GetMyNotMaintainNum({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyNotMaintainNum(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_GETMYNOTMAINTAINNUM_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_GETMYNOTMAINTAINNUM_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_ConfirmMaintained({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        confirmMaintained(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_CONFIRMMAINTAINED_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_CONFIRMMAINTAINED_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_AddMaintainDeviceRecord({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addMaintainDeviceRecord(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_ADDMAINTAINDEVICERECORD_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_ADDMAINTAINDEVICERECORD_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_ChangeMaintainer({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        changeMaintainer(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_CHANGEMAINTAINER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_CHANGEMAINTAINER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_GetMyMaintainPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyMaintainPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_GETMYMAINTAINPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_GETMYMAINTAINPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_ForceConfirmMaintained({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        forceConfirmMaintained(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_FORCECONFIRMMAINTAINED_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_FORCECONFIRMMAINTAINED_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_ModifyMaintainDeviceRecord({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyMaintainDeviceRecord(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_MODIFYMAINTAINDEVICERECORD_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_MODIFYMAINTAINDEVICERECORD_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_GetCanMakeRecordDevices({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getCanMakeRecordDevices(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_GETCANMAKERECORDDEVICES_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_GETCANMAKERECORDDEVICES_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_RemoveMaintainDeviceRecord({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        removeMaintainDeviceRecord(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_REMOVEMAINTAINDEVICERECORD_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_REMOVEMAINTAINDEVICERECORD_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_AddToRemark({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addToRemark(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_ADDTOREMARK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_ADDTOREMARK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_CallBack({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        callBack(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_CALLBACK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_CALLBACK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_GetTeamReport({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getTeamReport(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_GETTEAMREPORT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_GETTEAMREPORT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_Distribution({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        distribution(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_DISTRIBUTION_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_DISTRIBUTION_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_Cancel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        cancel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_CANCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_CANCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MaintainOrderServ_Reschedule({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        reschedule(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MAINTAINORDER_RESCHEDULE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MAINTAINORDER_RESCHEDULE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_MaintainOrder_ChangeBusinessUserResult: state => {
      return state.state_MaintainOrder_ChangeBusinessUserResult;
    },
    get_MaintainOrder_GetMyUserGroupPageResult: state => {
      return state.state_MaintainOrder_GetMyUserGroupPageResult;
    },
    get_MaintainOrder_GetMyUserGroupAllResult: state => {
      return state.state_MaintainOrder_GetMyUserGroupAllResult;
    },
    get_MaintainOrder_ModifyObjResult: state => {
      return state.state_MaintainOrder_ModifyObjResult;
    },
    get_MaintainOrder_AddObjResult: state => {
      return state.state_MaintainOrder_AddObjResult;
    },
    get_MaintainOrder_GetPageResult: state => {
      return state.state_MaintainOrder_GetPageResult;
    },
    get_MaintainOrder_GetAllResult: state => {
      return state.state_MaintainOrder_GetAllResult;
    },
    get_MaintainOrder_DeleteObjResult: state => {
      return state.state_MaintainOrder_DeleteObjResult;
    },
    get_MaintainOrder_GetDetailResult: state => {
      return state.state_MaintainOrder_GetDetailResult;
    },
    get_MaintainOrder_UploadMaintainPictureResult: state => {
      return state.state_MaintainOrder_UploadMaintainPictureResult;
    },
    get_MaintainOrder_RemoveMaintainPictureResult: state => {
      return state.state_MaintainOrder_RemoveMaintainPictureResult;
    },
    get_MaintainOrder_GetMyBusinessPageResult: state => {
      return state.state_MaintainOrder_GetMyBusinessPageResult;
    },
    get_MaintainOrder_GetMyGroupNotMaintainNumResult: state => {
      return state.state_MaintainOrder_GetMyGroupNotMaintainNumResult;
    },
    get_MaintainOrder_GetMyMaintainGroupPageResult: state => {
      return state.state_MaintainOrder_GetMyMaintainGroupPageResult;
    },
    get_MaintainOrder_GetMaintainGroupTeamReportResult: state => {
      return state.state_MaintainOrder_GetMaintainGroupTeamReportResult;
    },
    get_MaintainOrder_GetMyNotMaintainNumResult: state => {
      return state.state_MaintainOrder_GetMyNotMaintainNumResult;
    },
    get_MaintainOrder_ConfirmMaintainedResult: state => {
      return state.state_MaintainOrder_ConfirmMaintainedResult;
    },
    get_MaintainOrder_AddMaintainDeviceRecordResult: state => {
      return state.state_MaintainOrder_AddMaintainDeviceRecordResult;
    },
    get_MaintainOrder_ChangeMaintainerResult: state => {
      return state.state_MaintainOrder_ChangeMaintainerResult;
    },
    get_MaintainOrder_GetMyMaintainPageResult: state => {
      return state.state_MaintainOrder_GetMyMaintainPageResult;
    },
    get_MaintainOrder_ForceConfirmMaintainedResult: state => {
      return state.state_MaintainOrder_ForceConfirmMaintainedResult;
    },
    get_MaintainOrder_ModifyMaintainDeviceRecordResult: state => {
      return state.state_MaintainOrder_ModifyMaintainDeviceRecordResult;
    },
    get_MaintainOrder_GetCanMakeRecordDevicesResult: state => {
      return state.state_MaintainOrder_GetCanMakeRecordDevicesResult;
    },
    get_MaintainOrder_RemoveMaintainDeviceRecordResult: state => {
      return state.state_MaintainOrder_RemoveMaintainDeviceRecordResult;
    },
    get_MaintainOrder_AddToRemarkResult: state => {
      return state.state_MaintainOrder_AddToRemarkResult;
    },
    get_MaintainOrder_CallBackResult: state => {
      return state.state_MaintainOrder_CallBackResult;
    },
    get_MaintainOrder_GetTeamReportResult: state => {
      return state.state_MaintainOrder_GetTeamReportResult;
    },
    get_MaintainOrder_DistributionResult: state => {
      return state.state_MaintainOrder_DistributionResult;
    },
    get_MaintainOrder_CancelResult: state => {
      return state.state_MaintainOrder_CancelResult;
    },
    get_MaintainOrder_RescheduleResult: state => {
      return state.state_MaintainOrder_RescheduleResult;
    },
  }
}